<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Filter Induction Report</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close Filter Induction Report"
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="filter-content d-flex m-0 pt-4 pb-2 flex-wrap" style="justify-content: space-evenly">

  <ng-container matColumnDef="accounts">
    <div style="padding: 5px !important;">
      <button
        mat-raised-button
        type="button"
        (click)="onChangeSelectedAccount()"
        [matBadge]="'' + (filter_options.account_ids.length || 'All')"
        class="mx-3 mt-2">
        <mat-icon>business</mat-icon> Companies
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="users">
    <div style="padding: 5px !important;">
      <button
        mat-raised-button
        type="button"
        (click)="onSelectUsers()"
        [matBadge]="'' + (filter_options.user_ids.length || 'All')"
        class="mx-3 mt-2">
        <mat-icon>account_circle</mat-icon> Assigned Users
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="status">
    <div style="padding: 5px !important;">
      <mat-form-field class="mx-3 mt-2" style="width: 140px;" appearance="outline" subscriptSizing="dynamic">
        <mat-label>Status</mat-label>
        <mat-select placeholder="Status" class="filter-dropdowns" [(ngModel)]="filter_options.status" matTooltip="Filter induction report by status." name="status">
          <mat-option value="">All</mat-option>
          <mat-option value="not started">Not Started</mat-option>
          <mat-option value="in progress">In Progress</mat-option>
          <mat-option value="completed">Completed</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex flex-wrap justify-content-center my-2 py-2">

  <ng-container matColumnDef="buttons">
    <div class="p-2">
      <button
        type="button"
        mat-raised-button
        color="primary"
        (click)="onSaveAndClose()">
        <mat-icon>filter_list</mat-icon> Apply Filter
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="buttons">
    <div class="p-2">
      <button
        type="button"
        mat-raised-button
        color="secondary"
        (click)="onClearAndClose()">
        <mat-icon> clear_all</mat-icon> Clear Filter
      </button>
    </div>
  </ng-container>

</mat-dialog-actions>
